var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.isShownOnItemPageCount
      ? _c(
          "div",
          _vm._l(_vm.propertyGroup.properties, function (property) {
            return _c(
              "div",
              {
                key: property.id,
                class: _vm.paddingClasses,
                style: _vm.paddingInlineStyles,
              },
              [
                property.isShownOnItemPage && _vm.isCharityProperty(property)
                  ? _c("charity-order-property-list-item", {
                      attrs: {
                        group: _vm.propertyGroup.group,
                        charity: _vm.getCharity(property),
                        property: property,
                      },
                    })
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }